import { safeLocalStorage } from '@ifixit/utils';
import { type PromptHistory, canAutoOpen, recordAnswered, recordDismissed } from './prompt-history';

const STORAGE_KEY = 'feedback-prompt-history';

function read(): PromptHistory {
   try {
      return safeLocalStorage.getJson<PromptHistory>(STORAGE_KEY) ?? {};
   } catch {
      return {};
   }
}

function write(history: PromptHistory): void {
   try {
      safeLocalStorage.setJson(STORAGE_KEY, history);
   } catch {
      return;
   }
}

/** Without storage we can't remember who was asked, so only the tab shows. */
export function shouldAutoOpen(surface: string, now = Date.now()): boolean {
   if (!safeLocalStorage.isAvailable) {
      return false;
   }

   return canAutoOpen(read(), surface, now);
}

export function markAnswered(surface: string, now = Date.now()): void {
   write(recordAnswered(read(), surface, now));
}

export function markDismissed(surface: string, now = Date.now()): void {
   write(recordDismissed(read(), surface, now));
}
